export const REPORT_STATUS_TYPE = {
  QUEUED: 'queued',
  GENERATING: 'generating',
  GENERATED: 'generated',
  ERROR: 'error',
  TIMEOUT: 'timeout',
} as const;
